// Imports: local files.
import ApiClient from '../../services/ApiClient';

// Action Types: Get All Formal Education Resources.
export const GET_ALL_FORMAL_EDUCATION_RESOURCES_START = 'GET_ALL_FORMAL_EDUCATION_RESOURCES_START';
export const GET_ALL_FORMAL_EDUCATION_RESOURCES_SUCCESS = 'GET_ALL_FORMAL_EDUCATION_RESOURCES_SUCCESS';
export const GET_ALL_FORMAL_EDUCATION_RESOURCES_FAILED = 'GET_ALL_FORMAL_EDUCATION_RESOURCES_FAILED';
export const GET_ALL_FORMAL_EDUCATION_RESOURCES_RESET = 'GET_ALL_FORMAL_EDUCATION_RESOURCES_RESET';

// Action Types: Get One Formal Education Resource.
export const GET_ONE_FORMAL_EDUCATION_RESOURCE_START = 'GET_ONE_FORMAL_EDUCATION_RESOURCE_START';
export const GET_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'GET_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const GET_ONE_FORMAL_EDUCATION_RESOURCE_FAILED = 'GET_ONE_FORMAL_EDUCATION_RESOURCE_FAILED';
export const GET_ONE_FORMAL_EDUCATION_RESOURCE_RESET = 'GET_ONE_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Create New Formal Education Resource.
export const CREATE_FORMAL_EDUCATION_RESOURCE_START = 'CREATE_FORMAL_EDUCATION_RESOURCE_START';
export const CREATE_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'CREATE_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const CREATE_FORMAL_EDUCATION_RESOURCE_FAILED = 'CREATE_FORMAL_EDUCATION_RESOURCE_FAILED';
export const CREATE_FORMAL_EDUCATION_RESOURCE_RESET = 'CREATE_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Update One Formal Education Resource.
export const UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_START = 'UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_START';
export const UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED = 'UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED';
export const UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_RESET = 'UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Delete One Formal Education Resource.
export const DELETE_ONE_FORMAL_EDUCATION_RESOURCE_START = 'DELETE_ONE_FORMAL_EDUCATION_RESOURCE_START';
export const DELETE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'DELETE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const DELETE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED = 'DELETE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED';
export const DELETE_ONE_FORMAL_EDUCATION_RESOURCE_RESET = 'DELETE_ONE_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Upload Photo Formal Education Resource.
export const UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_START = 'UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_START';
export const UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_FAILED = 'UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_FAILED';
export const UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_RESET = 'UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Pin Formal Education Resource.
export const PIN_FORMAL_EDUCATION_RESOURCE_START = 'PIN_FORMAL_EDUCATION_RESOURCE_START';
export const PIN_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'PIN_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const PIN_FORMAL_EDUCATION_RESOURCE_FAILED = 'PIN_FORMAL_EDUCATION_RESOURCE_FAILED';
export const PIN_FORMAL_EDUCATION_RESOURCE_RESET = 'PIN_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Types: Unpin Formal Education Resource.
export const UNPIN_FORMAL_EDUCATION_RESOURCE_START = 'UNPIN_FORMAL_EDUCATION_RESOURCE_START';
export const UNPIN_FORMAL_EDUCATION_RESOURCE_SUCCESS = 'UNPIN_FORMAL_EDUCATION_RESOURCE_SUCCESS';
export const UNPIN_FORMAL_EDUCATION_RESOURCE_FAILED = 'UNPIN_FORMAL_EDUCATION_RESOURCE_FAILED';
export const UNPIN_FORMAL_EDUCATION_RESOURCE_RESET = 'UNPIN_FORMAL_EDUCATION_RESOURCE_RESET';

// Action Creators: Get All Formal Education Resources.
const getAllFormalEducationResourcesStart = (payload) => ({
  type: GET_ALL_FORMAL_EDUCATION_RESOURCES_START,
  payload,
});
const getAllFormalEducationResourcesSuccess = (payload) => ({
  type: GET_ALL_FORMAL_EDUCATION_RESOURCES_SUCCESS,
  payload,
});
const getAllFormalEducationResourcesFailed = (payload) => ({
  type: GET_ALL_FORMAL_EDUCATION_RESOURCES_FAILED,
  payload,
});
const getAllFormalEducationResourcesReset = () => ({ type: GET_ALL_FORMAL_EDUCATION_RESOURCES_RESET });

// Action Creators: Get One Formal Education Resource.
const getOneFormalEducationResourceStart = (payload) => ({
  type: GET_ONE_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const getOneFormalEducationResourceSuccess = (payload) => ({
  type: GET_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const getOneFormalEducationResourceFailed = (payload) => ({
  type: GET_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const getOneFormalEducationResourceReset = () => ({ type: GET_ONE_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Create New Formal Education Resource.
const createFormalEducationResourceStart = (payload) => ({
  type: CREATE_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const createFormalEducationResourceSuccess = (payload) => ({
  type: CREATE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const createFormalEducationResourceFailed = (payload) => ({
  type: CREATE_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const createFormalEducationResourceReset = () => ({ type: CREATE_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Update One Formal Education Resource.
const updateOneFormalEducationResourceStart = (payload) => ({
  type: UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const updateOneFormalEducationResourceSuccess = (payload) => ({
  type: UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const updateOneFormalEducationResourceFailed = (payload) => ({
  type: UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const updateOneFormalEducationResourceReset = () => ({ type: UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Delete One Formal Education Resource.
const deleteOneFormalEducationResourceStart = (payload) => ({
  type: DELETE_ONE_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const deleteOneFormalEducationResourceSuccess = (payload) => ({
  type: DELETE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const deleteOneFormalEducationResourceFailed = (payload) => ({
  type: DELETE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const deleteOneFormalEducationResourceReset = () => ({ type: DELETE_ONE_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Upload Photo Formal Education Resource.
const uploadPhotoFormalEducationResourceStart = (payload) => ({
  type: UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const uploadPhotoFormalEducationResourceSuccess = (payload) => ({
  type: UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const uploadPhotoFormalEducationResourceFailed = (payload) => ({
  type: UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const uploadPhotoFormalEducationResourceReset = () => ({ type: UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Pin Formal Education Resource.
const pinFormalEducationResourceStart = (payload) => ({
  type: PIN_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const pinFormalEducationResourceSuccess = (payload) => ({
  type: PIN_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const pinFormalEducationResourceFailed = (payload) => ({
  type: PIN_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const pinFormalEducationResourceReset = () => ({ type: PIN_FORMAL_EDUCATION_RESOURCE_RESET });

// Action Creators: Unpin Formal Education Resource.
const unpinFormalEducationResourceStart = (payload) => ({
  type: UNPIN_FORMAL_EDUCATION_RESOURCE_START,
  payload,
});
const unpinFormalEducationResourceSuccess = (payload) => ({
  type: UNPIN_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  payload,
});
const unpinFormalEducationResourceFailed = (payload) => ({
  type: UNPIN_FORMAL_EDUCATION_RESOURCE_FAILED,
  payload,
});
const unpinFormalEducationResourceReset = () => ({ type: UNPIN_FORMAL_EDUCATION_RESOURCE_RESET });

// Actions: Get All Formal Education Resources.
export const getAllFormalEducationResources = (payload) => {
  return async (dispatch) => {
    dispatch(
      getAllFormalEducationResourcesStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { page, limit, pagination, selectedLanguage, title } = payload;
      const params = {
        page,
        limit,
        pagination,
        selectedLanguage,
        ...(title && { title }),
      };

      const result = await ApiClient.get('formalEducationResources', { params });
      if (result.data?.success) {
        const { formalEducationResources } = result.data.data;
        dispatch(
          getAllFormalEducationResourcesSuccess({
            loading: false,
            success: true,
            data: { formalEducationResources },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getAllFormalEducationResourcesFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getAllFormalEducationResourcesFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get All Formal Education Resources.
export const clearGetAllFormalEducationResources = () => getAllFormalEducationResourcesReset();

// Actions: Get One Formal Education Resource.
export const getOneFormalEducationResource = (payload) => {
  return async (dispatch) => {
    dispatch(
      getOneFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { resourceId } = payload;
      const result = await ApiClient.get(`formalEducationResources/${resourceId}`);
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          getOneFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getOneFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getOneFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get One Formal Education Resource.
export const clearGetOneFormalEducationResource = () => getOneFormalEducationResourceReset();

// Actions: Create New Formal Education Resource.
export const createFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      createFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { formData } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.post('formalEducationResources', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          createFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          createFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        createFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Create New Formal Education Resource.
export const clearCreateFormalEducationResource = () => createFormalEducationResourceReset();

// Actions: Update One Formal Education Resource.
export const updateOneFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      updateOneFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { resourceId, formData } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put(`formalEducationResources/${resourceId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          updateOneFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          updateOneFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        updateOneFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Update One Formal Education Resource.
export const clearUpdateOneFormalEducationResource = () => updateOneFormalEducationResourceReset();

// Actions: Delete One Formal Education Resource.
export const deleteOneFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      deleteOneFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { resourceId } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.delete(`formalEducationResources/${resourceId}`);
      if (result.data?.success) {
        dispatch(
          deleteOneFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: null,
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          deleteOneFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        deleteOneFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Delete One Formal Education Resource.
export const clearDeleteOneFormalEducationResource = () => deleteOneFormalEducationResourceReset();

// Actions: Upload Photo Formal Education Resource.
export const uploadPhotoFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      uploadPhotoFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { resourceId, formData } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put(`formalEducationResources/${resourceId}/photo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          uploadPhotoFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          uploadPhotoFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        uploadPhotoFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Upload Photo Formal Education Resource.
export const clearUploadPhotoFormalEducationResource = () => uploadPhotoFormalEducationResourceReset();

// Actions: Pin Formal Education Resource.
export const pinFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      pinFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { resourceId } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put(`formalEducationResources/${resourceId}/pin`);
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          pinFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          pinFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        pinFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );

      // Handle specific pin limit error
      if (error?.errorType === 'PIN_LIMIT_EXCEEDED') {
        toastNotification('error', error.message || 'Maximum of 3 formal education resources can be pinned!');
      } else {
        toastNotification('error', onFailMessage);
      }
    }
  };
};

// Actions: Clear Pin Formal Education Resource.
export const clearPinFormalEducationResource = () => pinFormalEducationResourceReset();

// Actions: Unpin Formal Education Resource.
export const unpinFormalEducationResource = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      unpinFormalEducationResourceStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { resourceId } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put(`formalEducationResources/${resourceId}/unpin`);
      if (result.data?.success) {
        const { formalEducationResource } = result.data.data;
        dispatch(
          unpinFormalEducationResourceSuccess({
            loading: false,
            success: true,
            data: { formalEducationResource },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          unpinFormalEducationResourceFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        unpinFormalEducationResourceFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );

      // Handle specific errors
      if (error?.errorType === 'PIN_LIMIT_EXCEEDED') {
        toastNotification('error', error.message || 'Maximum of 3 formal education resources can be pinned!');
      } else {
        toastNotification('error', onFailMessage);
      }
    }
  };
};

// Actions: Clear Unpin Formal Education Resource.
export const clearUnpinFormalEducationResource = () => unpinFormalEducationResourceReset();
